export default (payment) => ({
  payerName: payment?.payerName || "",
  companyName: payment?.companyName || "",
  type: payment?.type || "",
  date: payment?.date || "",
  offerName: payment?.offerName || "",
});
